import { getAuthHeaders, handleAPIResponse } from '@/utils/apiUtils';
import {
  FilterOptions,
  SearchFilters,
  SearchResponse,
  MessageContent,
  MessageResponse,
  CandidateDetails,
  AdminOrganisationOption,
  AdminEmployeeOption,
  ImpersonationTokenResponse,
} from '@/types/admin';

const API_BASE_URL = `${process.env.NEXT_PUBLIC_API_URL}/admin`;

export const adminApi = {
  getFilters: async (): Promise<FilterOptions> => {
    const response = await fetch(`${API_BASE_URL}/filters`, {
      headers: getAuthHeaders(),
    });
    return handleAPIResponse<FilterOptions>(response);
  },

  getOrganisationsForSwitcher: async (
    q?: string,
    limit: number = 50
  ): Promise<{ organisations: AdminOrganisationOption[] }> => {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (q?.trim()) params.set('q', q.trim());
    const response = await fetch(`${API_BASE_URL}/organisations?${params.toString()}`, {
      headers: getAuthHeaders(),
    });
    return handleAPIResponse<{ organisations: AdminOrganisationOption[] }>(response);
  },

  getOrganisationEmployees: async (organisationId: string): Promise<{ employees: AdminEmployeeOption[] }> => {
    const response = await fetch(`${API_BASE_URL}/organisations/${organisationId}/employees`, {
      headers: getAuthHeaders(),
    });
    return handleAPIResponse<{ employees: AdminEmployeeOption[] }>(response);
  },

  impersonateOrganisation: async (organisationId: string, employeeId: string): Promise<ImpersonationTokenResponse> => {
    const response = await fetch(`${API_BASE_URL}/organisations/${organisationId}/impersonate`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ employeeId }),
    });
    return handleAPIResponse<ImpersonationTokenResponse>(response);
  },

  searchCandidates: async (
    filters?: SearchFilters,
    page: number = 1,
    limit: number = 20
  ): Promise<SearchResponse['data']> => {
    const response = await fetch(`${API_BASE_URL}/candidates/search`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        filters,
        page,
        limit: 300,
      }),
    });
    return handleAPIResponse<SearchResponse['data']>(response);
  },

  getCandidateDetails: async (candidateId: number): Promise<CandidateDetails> => {
    const response = await fetch(`${API_BASE_URL}/candidates/${candidateId}`, {
      headers: getAuthHeaders(),
    });
    const result = await handleAPIResponse<{ message: string; data: CandidateDetails }>(response);
    return result.data;
  },

  sendMessages: async (
    candidateIds: number[],
    channels: ('email' | 'whatsapp')[],
    content: MessageContent
  ): Promise<MessageResponse['data']> => {
    const response = await fetch(`${API_BASE_URL}/candidates/send-messages`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        candidateIds,
        channels,
        ...content,
      }),
    });
    return handleAPIResponse<MessageResponse['data']>(response);
  },
};


